import { createSelector } from 'reselect';
import get from 'lodash/get';

export const requestSelector = state => state.requestError;

export const visibleRequestErrorSelector = createSelector(
  requestSelector,
  subState => subState.show
);

export const typeErrorRequestSelector = createSelector(
  requestSelector,
  subState => get(subState, 'typeError', null)
);

export const requestCausedErrorSelector = createSelector(
  requestSelector,
  subState => get(subState, 'requestCausedError', null)
);

export const statusRequestErrorSelector = createSelector(
  requestSelector,
  subState => get(subState, 'error.status', null)
);

export const jsonRequestErrorSelector = createSelector(
  requestSelector,
  subState => get(subState, 'error.json', null)
);
